import { BrowserRouter } from 'react-router-dom';

import { AppRouter } from '../routers';

export const withRouter = () => () => {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
};
